import { useInvoicesViewStore } from '@/store/invoices-view';

import { useInvoicesListSearchController } from './useTopbarSearchControllers';

export function useInvoicesListTopbarState() {
  const searchFilter = useInvoicesViewStore((state) => state.filters.search);
  const setFilters = useInvoicesViewStore((state) => state.setFilters);
  const groupBy = useInvoicesViewStore((state) => state.groupBy);
  const setGroupBy = useInvoicesViewStore((state) => state.setGroupBy);

  const { searchInput, handleSearchChange } = useInvoicesListSearchController({
    searchFilter,
    setFilters,
  });

  return {
    searchInput,
    handleSearchChange,
    groupBy,
    setGroupBy,
  };
}
